import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ToggleSearch {}

export const toggleSearch = createAction<ActionType, ToggleSearch>(
    ActionType.NOTI__EC__TOGGLE_SEARCH,
);
